import produce from 'immer';

export default (initial, types) =>
  (state = initial, {type, ...action}) =>
    produce(state, draft => {
      type in types
        ? types[type](draft, action, state)
        : state;
    } )
